import { z } from "zod";
export const ContactCentreMeResponse = z.object({
    userId: z.string(),
    roles: z.array(z.string()),
    capabilities: z.array(z.string()),
    companyId: z.string().nullable(),
    canAccessContactCentre: z.literal(true),
});
export const ContactCentreResetResponse = z.object({
    id: z.string().nullable(),
    videoUrl: z.string().nullable(),
});
//# sourceMappingURL=contact-centre.js.map